import React from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import TopSection from '../../components/UmrahVisa/TopSection';
import ContactForm from '../../components/UmrahVisa/CookiePolicy';

import CustomizeSection from '../../components/Home3/CustomizeSection';



const CookiePolicyIndex=props=>{

    return(
        <div>
            <Navbar bg={1}/>
            <div className='max-md:p-3'>
            <TopSection/>
            <ContactForm/>
            <CustomizeSection/>
            </div>
            <Footer/>
        </div>
    )
}
export default CookiePolicyIndex